/**
 * Subscription Banner
 * Visar information om demo/trial-status
 */

import { usePermissionsStore } from '@/store/permissionsStore';
import { useTranslation } from '@/store/languageStore';
import { ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';

export const SubscriptionBanner = () => {
  const { t } = useTranslation();
  const { isDemo, isTrial, getTrialDaysRemaining } = usePermissionsStore();
  
  const isInDemo = isDemo();
  const isInTrial = isTrial();
  const daysRemaining = getTrialDaysRemaining();

  if (!isInDemo && !isInTrial) {
    return null;
  }

  if (isInDemo) {
    return (
      <div className="bg-amber-50 border-l-4 border-amber-400 p-3 mb-4">
        <div className="flex items-center">
          <InformationCircleIcon className="h-5 w-5 text-amber-400 mr-2" />
          <div>
            <p className="text-sm text-amber-700 font-medium">
              {t('copy.ui.demoMode')}
            </p>
            <p className="text-xs text-amber-600">
              {t('copy.ui.demoModeReadOnly')}
              {' '}
              {t('copy.ui.demoModeUpgrade')}
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (isInTrial && daysRemaining !== null) {
    const isUrgent = daysRemaining <= 3;
    const isWarning = daysRemaining <= 7;

    if (daysRemaining <= 0) {
      return (
        <div className="bg-red-50 border-l-4 border-red-400 p-3 mb-4">
          <div className="flex items-center">
            <ExclamationTriangleIcon className="h-5 w-5 text-red-400 mr-2" />
            <div>
              <p className="text-sm text-red-700 font-medium">
                {t('copy.ui.trialExpiredTitle')}
              </p>
              <p className="text-xs text-red-600">
                {t('copy.ui.trialExpiredBody')}
              </p>
            </div>
          </div>
        </div>
      );
    }

    if (isUrgent || isWarning) {
      return (
        <div className={`${isUrgent ? 'bg-red-50 border-red-400' : 'bg-amber-50 border-amber-400'} border-l-4 p-3 mb-4`}>
          <div className="flex items-center">
            <ExclamationTriangleIcon className={`h-5 w-5 ${isUrgent ? 'text-red-400' : 'text-amber-400'} mr-2`} />
            <div>
              <p className={`text-sm font-medium ${isUrgent ? 'text-red-700' : 'text-amber-700'}`}>
                {daysRemaining === 1
                  ? t('copy.ui.trialOneDayLeft')
                  : t('copy.ui.trialDaysLeft', { count: daysRemaining })}
              </p>
              <p className={`text-xs ${isUrgent ? 'text-red-600' : 'text-amber-600'}`}>
                {t('copy.ui.trialEndingSoon')}
              </p>
            </div>
          </div>
        </div>
      );
    }
  }

  return null;
};

export default SubscriptionBanner;
